"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ramda = require("ramda");
var _buildXml = require("@qdabra/build-xml");
var _xmldom = require("@xmldom/xmldom");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var createElement = (0, _buildXml.makeElementCreator)(null);
var getMappingElement = function getMappingElement(dom) {
  return function (field) {
    return createElement(dom, 'Mapping', {
      children: [createElement(dom, 'FormField', {
        attributes: {
          IsRichText: field.isRichText,
          IsId: field.isId,
          IsAttachment: field.isAttachment,
          IsDate: field.isDate,
          IsParentId: field.isParentId,
          IsPerson: field.isPerson
        },
        text: field.path
      }), createElement(dom, 'SharePointColumn', {
        text: field.sharePointColumn
      })]
    });
  };
};
var getMappingChildren = function getMappingChildren(dom, mappingFields) {
  return (0, _ramda.map)(getMappingElement(dom), mappingFields);
};

// [Mapping] -> { Number: String }
var makeParentMap = (0, _ramda.compose)(_ramda.fromPairs, (0, _ramda.chain)(function (m) {
  return (0, _ramda.map)(function (childId) {
    return [childId, m.name];
  }, m.children);
}));
var getMapping = (0, _ramda.curry)(function (dom, parentMap, mapping) {
  return createElement(dom, 'Mappings', {
    attributes: {
      mappingName: mapping.name
    },
    children: [createElement(dom, 'Properties', {
      children: [createElement(dom, 'Level', {
        text: mapping.level
      }), createElement(dom, 'ParentMapping', {
        text: parentMap[mapping.id] || ''
      })]
    }), createElement(dom, 'ListCollection', {
      attributes: {
        useName: mapping.useListName,
        ListName: mapping.listName
      },
      text: mapping.listId
    }), createElement(dom, 'IsRepeating', {
      text: mapping.isRepeating.toString()
    }), createElement(dom, 'RepeatingGroup', {
      text: mapping.basePath
    }), createElement(dom, 'Relationships', {
      children: [createElement(dom, 'RelatedList'), createElement(dom, 'RelatedListId')]
    })].concat(_toConsumableArray(getMappingChildren(dom, mapping.fields)))
  });
});
var getMappings = function getMappings(dom, mappings) {
  var allMappings = (0, _ramda.values)(mappings);
  var parentMap = makeParentMap(allMappings);
  return (0, _ramda.map)(getMapping(dom, parentMap), allMappings);
};
var _default = exports["default"] = function _default(mapping) {
  var schemaVersion = mapping.schemaVersion,
    sharePointSiteUrl = mapping.sharePointSiteUrl,
    mappings = mapping.mappings;
  var dom = (0, _buildXml.makeEmptyDom)(new _xmldom.DOMParser());
  var myFields = createElement(dom, 'myFields', {
    attributes: {
      schemaVersion: schemaVersion
    },
    children: [].concat(_toConsumableArray(getMappings(dom, mappings)), [createElement(dom, 'SharePointListURL', {
      text: sharePointSiteUrl
    })])
  });
  dom.appendChild(myFields);
  return dom;
};